import * as Yup from "yup"
import {
  ABOUT_YOU_DISPLAY_NAME_REQUIRED_ERROR,
  ABOUT_YOU_DOB_REQUIRED_ERROR,
  ABOUT_YOU_DOB_GREATER_THAN_18_YEARS_ERROR,
} from "../constants/messages"
import moment from "moment"

export const AboutYouValidation = Yup.object().shape({
  displayName: Yup.string()
    .required(ABOUT_YOU_DISPLAY_NAME_REQUIRED_ERROR)
    .nullable(),
  // dateOfBirth: Yup.date()
  //   .required(ABOUT_YOU_DOB_REQUIRED_ERROR)
  //   .test({
  //     name: "Below 18 check",
  //     test(value) {
  //       return Math.floor(
  //         moment(new Date()).diff(moment(value, "DD-MM-YYYY"), "years", true)
  //       ) < 18
  //         ? this.createError({
  //             message: ABOUT_YOU_DOB_GREATER_THAN_18_YEARS_ERROR,
  //           })
  //         : true
  //     },
  //   })
  //   .nullable(),
})
